import { ShareButtonNext } from 'components/common-form/sidePanel/docToolbar/summary';
import { PriceNext, QuoteStatus, SolveResult } from 'components/shared/PriceNext';
import { FC, PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import type { QuotedNonTradableState } from './Quoted.NonTradable.connect';
import { connectQuotedNonTradeable } from './Quoted.NonTradable.connect';

export const Component: FC<PropsWithChildren<QuotedNonTradableState>> = ({
  tabId,
  solveResult,
  solveResultFormat,
  solvingMode,
  workspaceType,
}) => {
  return (
    <PriceNext
      className="bg-danger text-danger bg-opacity-10"
      solveMode={
        <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
      }
      shareButton={<ShareButtonNext className="text-danger" tabId={tabId} />}
      solveResult={<SolveResult price={solveResult} priceFormat={solveResultFormat} />}
      quoteStatus={
        <QuoteStatus className="alert alert-danger" icon="block" description="sidePanel.quoteStatus.quoteRejected" />
      }
    />
  );
};

export const QuotedNonTradable = connectQuotedNonTradeable(Component);

Component.displayName = 'QuotedNonTradable';
